import React from 'react';
import styles from './SocialLinks.module.css';

export const SocialLinks = () => {
    return (
        <div className={styles.socialLinks}>
            <ul
                aria-label="Social Bar"
                className={styles.socialList}
            >
                <li className={styles.socialItem}>
                    <div aria-label="Instagram" className={styles.socialIcon}>
                        <div className={styles.iconContainer}>
                            <img
                                alt="Instagram"
                                src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/11062b_084cbbff6ae446c1b03dc3637193e77a~mv2.png"
                                className={styles.iconImage}
                            />
                        </div>
                    </div>
                </li>
                <li className={styles.socialItem}>
                    <div aria-label="Facebook" className={styles.socialIcon}>
                        <div className={styles.iconContainer}>
                            <img
                                alt="Facebook"
                                src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/11062b_1f7ed8bc7b004201970df69f9eeda689~mv2.png"
                                className={styles.iconImage}
                            />
                        </div>
                    </div>
                </li>
                <li className={styles.socialItem}>
                    <div aria-label="X" className={styles.socialIcon}>
                        <div className={styles.iconContainer}>
                            <img
                                alt="X"
                                src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/11062b_b08fccde70ca4f7a88b3e4c3a19246eb~mv2.png"
                                className={styles.iconImage}
                            />
                        </div>
                    </div>
                </li>
                <li className={styles.socialItem}>
                    <div aria-label="LinkedIn" className={styles.socialIcon}>
                        <div className={styles.iconContainer}>
                            <img
                                alt="LinkedIn"
                                src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/11062b_a06d85fa94d64ef68680321f5a043a8c~mv2.png"
                                className={styles.iconImage}
                            />
                        </div>
                    </div>
                </li>
                <li className={styles.socialItem}>
                    <div aria-label="Youtube" className={styles.socialIcon}>
                        <div className={styles.iconContainer}>
                            <img
                                alt="Youtube"
                                src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/11062b_6fc54c8957474101ba6e80b01907ae50~mv2.png"
                                className={styles.iconImage}
                            />
                        </div>
                    </div>
                </li>
                <li className={styles.socialItem}>
                    <div aria-label="TikTok" className={styles.socialIcon}>
                        <div className={styles.iconContainer}>
                            <img
                                alt="TikTok"
                                src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/11062b_4b88b89fe4694d949be4919c81f194b4~mv2.png"
                                className={styles.iconImage}
                            />
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    );
};